// ============================================================================
// JAPANESE TRANSLATIONS - UNITY MODULE (日本語)
// ============================================================================

export const unityTranslations = {
  title: "平和をもたらす一致",
  author: "エマニュエル著",
  subtitle: "それぞれの宗教には理由があり、私たちの境界は過去から来ています",
  description: "精神的な一致と伝統間の平和についての考察モジュール",
  
  nav: {
    intro: "序論",
    religions: "諸宗教",
    common: "共通の基盤",
    humility: "謙遜"
  },

  intro: {
    emmanuelSays: "エマニュエルは言います：",
    ourBordersFromPast: "私たちの境界は過去から来ています",
    bordersDescription: "それぞれの宗教には理由があります。私たちの分裂は神の意志ではなく、歴史、地理、文化の産物です。",
    divisionWork: "分裂、恐怖の障壁と境界による孤立は、私たちの危険な過去の作品です。",
    sharedHumanity: "私たちは異なる伝統に生まれましたが、同じ人類を共有しています。",
    
    revelationTitle: "目を開かせる啓示",
    surprisedLearning: "ある日、ユダヤ人も神の子であることを知って驚きました。",
    angelMichael: "天使ミカエルがイスラム教徒にとって偉大な使者であることを。",
    jesusNames: "イエス、イーサー、イェシュアがキリスト教信仰の中でさえ様々な形で知られていることを。",
    diverseTribes: "なぜなら、多様な部族、多様な教会、多様な家族が存在するからです。",
    sameRealities: "私たちは異なる名前で同じ現実について語っています。これは私たちを分断するのではなく、近づけるべきです。",
    
    respectTitle: "尊重：謙遜の土台、平和の守護者",
    respectFoundation: "兄弟愛が客観的に適用できないとしても、尊重は謙遜の土台であり、平和の守護者です。",
    understandingProcess: "他の宗教を理解し尊重することは謙遜のプロセスです。これは自分の信仰を放棄することではなく、他者も真理を求めていることを受け入れることです。",
    
    whatBindsUs: "私たちを本当に結びつけるもの",
    seekingRelation: "すべての宗教は関係を求めています。すべての人は平和を求めています。",
    loveOfGod: "私たち全員を結びつけるこの関係は、神の愛です。",
    universalLink: "愛はすべての境界、すべての言語、すべての伝統を超越する普遍的な絆です。",
    
    inclusionTitle: "包摂：宗教的多様性よりもさらに広大",
    vastInclusion: "宗教的多様性は広大ですが、神に召された場所にいる他者を包摂することはさらに広大です。",
    respectDifferences: "肌の色や性別の違いを尊重し、包摂することが、神に愛されるユニークな人間にしてくれます。",
    jesusCommand: "イエスは言いました：『互いに愛し合いなさい。』",
    
    communitySpirit: "共同体主義の精神との決別",
    communityTerror: "共同体主義は偽装された悪の憎しみの恐怖です。それは信仰を部族のアイデンティティに、分離する壁に、傷つける武器に変えます。",
    pridePolitics: "私たちの党派精神は、傲慢の政治へと私たちを押しやります：",
    prideQuotes: "私はあなたを傷つける権利がある。私は正しい、それだけだ。私は正義の戦争をする権利がある。",
    watchHeart: "問題の核心、私たち自身の悪の根源に注意してください。",
    refuseDivision: "神の名において人類を分断するこの漂流を拒否しましょう。",
    
    freedomTitle: "自由であるために、他者を自由にする",
    freedomOthers: "自由であるためには、他者も自由にする方法を知らなければなりません。",
    defendFreedom: "私の信じる自由は、すべての人の自由を守ってこそ価値があります。他者を抑圧することは、自分自身を隷属に追い込むことです。",
    
    changeHeartTitle: "あなたの心を変えなさい：真の灯となりなさい",
    recognizeDecency: "品位が各人にとって同じではないことを認識してください。",
    changeYourself: "まず自分から徐々に変わりなさい。あなたの心を変え、あなたの人生を変容させ、真の灯となりなさい。",
    beExample: "芝生におしっこをしてはいけない、枯れてしまうから...他者にあなたの規則を押し付けるのではなく、あなたの変容を通じて生きた模範となりなさい。",
    
    childrenPeaceTitle: "私たちの子どもたちは多様性の中で平和に生きるでしょう",
    avoidPursuit: "言葉のための言葉の追求を避けてください。",
    peaceChoice: "今日尊重を選択すれば、未来の私たちの子どもたちは多様性の中で平和に生きるでしょう。平和は今、私たちの言葉と行動において、私たちから始まります。",
    
    discernTitle: "見分ける：人間か神か？",
    manSpeaks: "あまりにも多くの場合、語り分断するのは人間の心です。",
    seeFruits: "私たちは言葉の実によってそれを見ます：盗み、破壊、戦争。自分の傲慢に資するために言葉を操作することに注意してください。",
    
    lookPeaceTitle: "平和と愛を見る",
    lookPeaceAll: "すべての人のための平和を見、他者のための神の愛を見てください。",
    godSpeaks: "言葉が平和、和解、一致を生み出すとき：それは神が語っています。言葉が分裂、憎しみ、戦争を生み出すとき：それは人間の傲慢です。",
    
    watchWordsTitle: "私たちの言葉に気をつける",
    watchShares: "私たちの分かち合いに気をつけ、他者に対する有害な反対の言葉に気をつけてください。",
    disqualify: "これらの悪は私たち自身を失格させます。私たちの言葉の実は、私たちの中で誰が語っているかを明らかにします：神か、それとも私たち自身の傲慢か？",
    
    wisdomMaturityTitle: "私たちの本性に直面した知恵と成熟",
    useScriptures: "聖書（律法）を使って害を与えることは私たちの習慣であり、ほぼ自然でいたずらなプロセスです。",
    hateSin: "私たちの罪深い本性に直面して、私たちは悪と悪を行う人々を憎みます。",
    separateActs: "しかし、知恵と成熟によって、行為を私たちの人間的貧困から分離しなければなりません。",
    compassionNature: "文脈に応じて自己を守りながら、慈悲と恵みを必要とする私たちの動物的本性を認識してください。",
    
    denounceLeadersTitle: "腐敗した霊的指導者を告発する",
    watchLeaders: "自分たちの堕落と不誠実さを秘密にしようとする霊的指導者や指導者に注意してください。",
    noJustice: "正義がなければ、模範もありません。知識がなければ、私たちの沈黙によって他の犠牲者が滅びます。",
    silenceComplicity: "不正義に直面した沈黙は共謀です。他者を守るために真実を語らなければなりません。"
  },

  religions: {
    title: "多様な宗教、一つの人類",
    intro: "キリスト教徒、イスラム教徒、ユダヤ教徒、ヒンドゥー教徒、仏教徒...そして他の多くの人々：すべてが真理を求めています",
    theirGod: "彼らの神：",
    theGood: "善：",
    theEvil: "悪：",
    theAngels: "天使たち：",
    theUnity: "一致：",
    values: "価値観：",
    commonGoal: "共通の目標",
    seekingPeace: "すべての宗教は共通の目標を共有しています：平和を求め、愛を促進し、より良い世界を築くこと。私たちの違いを超えて、知恵と調和を求めるこの探求において、私たちは皆団結しています。",
    
    christianity: {
      name: "キリスト教",
      godText: "唯一の神、創造主なる父",
      goodText: "隣人愛、赦し、平和",
      evilText: "憎しみ、利己主義、暴力",
      angelsText: "神の使者たち（ガブリエル、ミカエル...）",
      unityText: "すべての人のための唯一の神",
      values: "愛,赦し,平和,謙遜,正義"
    },
    islam: {
      name: "イスラム教",
      godText: "アッラー、唯一にして慈悲深き方",
      goodText: "正義、慈善、平和",
      evilText: "抑圧、嘘、分裂",
      angelsText: "光の天使たち（ジブリール、ミーカーイール...）",
      unityText: "アッラーの他に神はなし",
      values: "平和,正義,慈善,尊重,慈悲"
    },
    judaism: {
      name: "ユダヤ教",
      godText: "ヤハウェ、唯一の永遠なる方",
      goodText: "正義、慈悲、命",
      evilText: "抑圧、中傷、憎しみ",
      angelsText: "天の使者たち（マラキーム）",
      unityText: "聞け、イスラエルよ、主は唯一なり",
      values: "正義,命,記憶,平和,学び"
    },
    hinduism: {
      name: "ヒンドゥー教",
      godText: "ブラフマン、至高の実在",
      goodText: "非暴力（アヒンサー）、正しい義務",
      evilText: "暴力、霊的無知",
      angelsText: "デーヴァ、慈悲深き天の存在",
      unityText: "すべてはブラフマンにおいて一つ",
      values: "非暴力,真実,慈悲,純粋,調和"
    },
    buddhism: {
      name: "仏教",
      godText: "創造神はないが、神聖なるものへの敬意",
      goodText: "慈悲、智慧、平和",
      evilText: "無知によって引き起こされる苦しみ",
      angelsText: "菩薩たち、覚醒した存在",
      unityText: "すべての人の中の仏性",
      values: "慈悲,智慧,平和,非暴力,覚醒"
    }
  },

  common: {
    title: "共通の基盤",
    intro: "善、悪、天使、唯一の神、関係、包摂：人類を結びつけるもの",
    
    goodTitle: "善",
    goodDescription: "すべての宗教が愛、正義、慈悲を教えています",
    goodExamples: "自分自身のように隣人を愛せよ|区別なく善を行え|弱者と抑圧された者を守れ|親切に真実を語れ|持っているものを分かち合え",
    
    evilTitle: "悪",
    evilDescription: "すべてが暴力、嘘、抑圧を非難します",
    evilExamples: "正義なく殺すこと|盗み搾取すること|嘘をつき中傷すること|軽蔑し屈辱を与えること|分裂させ憎むこと",
    
    angelsTitle: "天使と霊的存在",
    angelsDescription: "ほぼすべてが慈悲深き天の使者を認めています",
    angelsExamples: "神の使者である天使たち|霊的導き手|光の存在|天の守護者|菩薩とデーヴァ",
    
    godTitle: "唯一の神（または至高の実在）",
    godDescription: "大多数が唯一の源、創造主、または究極の実在を信じています",
    godExamples: "キリスト教、イスラム教、ユダヤ教：唯一の神|ヒンドゥー教：至高の一なるブラフマン|仏教：普遍的な仏性|すべてが究極の真理を求めています|すべてが一致と平和を希求しています",
    
    relationTitle: "関係と平和",
    relationDescription: "すべての宗教とすべての人を本当に結びつけるもの",
    relationExamples: "すべての宗教が神との関係を求めています|すべての人が平和を求めています|私たち全員を結びつけるこの関係は神の愛です|愛は普遍的な絆です|平和は私たちの共通の希求です",
    
    inclusionTitle: "包摂：神に愛されている",
    inclusionDescription: "宗教的多様性は広大ですが、包摂はさらに広大です",
    inclusionExamples: "神に召された場所にいる他者の包摂|肌の色の違いへの尊重|性別の違いへの尊重|包摂が私たちを神に愛されるユニークな人間にします|イエスは言いました：『互いに愛し合いなさい』",
    
    finalQuote: "ある日、ユダヤ人も神の子であること、天使ミカエルがイスラム教徒にとって偉大な使者であること、イエス、イーサー、イェシュアがキリスト教信仰の中でさえ様々な形で知られていることを知って驚きました。なぜなら、多様な部族、多様な教会、多様な家族が存在するからです。",
    finalQuote2: "私たちは異なる名前で同じ現実について語っています。",
    quoteAuthor: "エマニュエル、平和をもたらす一致"
  },

  humility: {
    title: "謙遜と平和への7つのステップ",
    intro: "共同体主義を超え、真の灯となるためのプロセス",
    
    step: "ステップ",
    action: "行動：",
    
    step1Title: "認識する：私たちの境界は過去から来ている",
    step1Description: "分裂、恐怖の障壁と境界による孤立は、私たちの危険な過去の作品です。私たちの分裂は神の意志ではありません。",
    step1Action: "私の伝統は私だけのものであり、私は神が望まれた多様性の一部であることを受け入れる",
    
    step2Title: "尊重：謙遜の土台、平和の守護者",
    step2Description: "兄弟愛が客観的に適用できないとしても、尊重は基礎です。",
    step2Action: "すべてを理解しなくても、すべての信仰を尊重する",
    
    step3Title: "裁かずに理解する",
    step3Description: "今日、他者を理解することは必要な謙遜のプロセスです。",
    step3Action: "裁きなしに、他者が信じることを本当に聴く",
    
    step4Title: "まず自分から変わる：真の灯となる",
    step4Description: "品位が各人にとって同じではないことを認識してください。徐々にあなたの心を変え、あなたの人生を変容させ、真の光となってください。",
    step4Action: "他者に私の規則を押し付けるのではなく、私の変容を通じて生きた模範となる",
    
    step5Title: "共同体主義の精神との決別",
    step5Description: "私たちの党派精神は、傲慢の政治へと私たちを押しやります：『私はあなたを傷つける権利がある、私は正しい、それだけだ。』問題の核心、私たち自身の悪の根源に注意してください。",
    step5Action: "自分のコミュニティ内で分裂の言説を拒否する",
    
    step6Title: "自由であるために、他者を自由にする",
    step6Description: "私の自由は、私が他者に与える自由にかかっています。",
    step6Action: "私だけでなく、すべての人の良心の自由を守る",
    
    step7Title: "言葉のための言葉の追求を避ける",
    step7Description: "憎しみに憎しみで、侮辱に侮辱で応答しないでください。",
    step7Action: "私たちの子どもたちが多様性の中で平和に生きるために、平和を選択する",
    
    discernFruits: "実によって見分ける",
    humanHeart: "分断する人間の心",
    lookGodLove: "神の愛を見る",
    watchOurWords: "私たちの言葉に気をつける",
    
    prideFruits: "人間の傲慢の実",
    godFruits: "神の愛の実",
    
    finalQuote: "兄弟愛が客観的に適用できないとしても、尊重は謙遜の土台であり、平和の守護者です。言葉のための言葉の追求を避ければ、未来の私たちの子どもたちは多様性の中で平和に生きるでしょう。",
    author: "エマニュエル"
  },

  footer: {
    quote: "尊重は謙遜の土台であり、平和の守護者です。今日尊重を選択すれば、私たちの子どもたちは多様性の中で平和に生きるでしょう。",
    author: "エマニュエル、平和をもたらす一致"
  }
};

export default unityTranslations;
